import { getCookie } from '@/resources/utils'

export const isAuthenticated = () => !!getCookie('is_authenticated')
